import { render, staticRenderFns } from "./TheProfileFieldsetContact.vue?vue&type=template&id=796f8aa2&"
import script from "./TheProfileFieldsetContact.vue?vue&type=script&lang=js&"
export * from "./TheProfileFieldsetContact.vue?vue&type=script&lang=js&"
import style0 from "./TheProfileFieldsetContact.vue?vue&type=style&index=0&id=796f8aa2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports